// extracted by mini-css-extract-plugin
export default {"projectItemCard":"ProjectListItem_projectItemCard__vC0bN","moreBtn":"ProjectListItem_moreBtn__HsLtL","folderIcon":"ProjectListItem_folderIcon__aGauj"};